var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4000 4000",
    style: {
      enableBackground: "new 0 0 4000 4000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#04B74D;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2000,529.02c-812.4,0-1470.98,658.58-1470.98,1470.98S1187.6,3470.98,2000,3470.98 S3470.98,2812.4,3470.98,2000S2812.4,529.02,2000,529.02z M2000,3424.66c-786.82,0-1424.66-637.84-1424.66-1424.66 S1213.18,575.34,2000,575.34S3424.66,1213.18,3424.66,2000S2786.82,3424.66,2000,3424.66z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2000,
    cy: 2000,
    r: 1385.28
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2168.6,3779.64v0.17c0,14.87,12.9,26.44,27.69,24.85c859.8-92.44,1539.74-785.49,1611.88-1651.2 c1.22-14.58-10.27-27.1-24.91-27.1h-0.17c-13.03,0-23.83,10.01-24.91,22.99c-70.19,841.69-731.26,1515.51-1567.19,1605.44 C2178.27,3756.16,2168.6,3766.85,2168.6,3779.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3760.37,1703h0.02c15.63,0,27.48-14.15,24.68-29.53C3642.45,890.61,2997.48,283.02,2196.35,196.85 c-14.82-1.59-27.75,10.03-27.75,24.94v0c0,12.79,9.62,23.55,22.33,24.92c778.92,83.77,1406.02,674.5,1544.75,1435.64 C3737.87,1694.29,3748.23,1703,3760.37,1703z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1745.24,233.22L1745.24,233.22c0-15.39-13.74-27.18-28.94-24.79 C956.07,327.85,352.53,919.35,215.15,1673.47c-2.8,15.38,9.06,29.53,24.69,29.53h0c12.09,0,22.49-8.62,24.66-20.52 C398.1,949.24,984.92,374.11,1724.11,257.98C1736.29,256.07,1745.24,245.54,1745.24,233.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.05,2126.36L217.05,2126.36c-14.68,0-26.21,12.55-24.99,27.18 c69.71,836.04,706.26,1511.04,1524.23,1639.54c15.21,2.39,28.96-9.39,28.96-24.78v-0.01c0-12.37-9.03-22.86-21.25-24.78 c-795.29-125-1414.19-781.33-1481.95-1594.23C240.95,2136.31,230.07,2126.36,217.05,2126.36z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1951.4,
    cy: 210.44,
    r: 41.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1951.76,
    cy: 3789.56,
    r: 41.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 214.22,
    cy: 1915.22,
    r: 41.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 3785.78,
    cy: 1913.06,
    r: 41.04
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2607.5,1301.35c86.27,30.61,192.48,143.62,265.46,203.06c-335.39,423-766.23,805.84-1144.12,1194.25 c-101.14-107.89-207.25-212.2-310.81-317.99c-100.83-102.91-195.01-212.81-290.99-320.32c75.3-71.72,158.31-137.37,237.62-204.83 c124.03,114.42,241.94,234.72,360.38,354.93C2024.68,1914.23,2326.64,1615.54,2607.5,1301.35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.df7753fbd058a111a28d331e7f0746e4.svg";
export { ForwardRef as ReactComponent };